module.exports = __webpack_public_path__ + "img/cs.8f9e3dcc.svg";